var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.divClass},[_c('div',[_c('button',{class:_vm.buttonClass,style:(_vm.btnStyle),attrs:{"type":"button","data-cy":"button-choose-photo"},on:{"click":_vm.onButtonChoosePhoto}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }